import React from 'react';
import { STAGE_META, STAGE_TONE_CLS } from './constants';
import { PendingReviewTrigger } from './PendingReviewPopover';

// 一個 engagement 走到哪一關的兩種呈現，兩頁共用：
//   StageChip           — Engagement Progress 表格裡的單一關卡
//   EngagementStageBadge — 「卡在哪」的總結（Progress 的 Current stage 欄、
//                          Overview 的 My engagements）
//
// label 與 tone 都由後端算好（server/services/engagementStage.js）——前端只
// 負責挑顏色。這是刻意的：兩個畫面各自判斷的話遲早分歧，而分歧不會噴錯，
// 只會靜靜地在兩頁顯示不同的答案。
// 「在審」＝點得開「在等誰簽核」。**能力做在這兩個元件
// 裡,不是做在頁面裡**：Progress、Overview、Management 的 Engagements 與
// My Records 都渲染它們,各畫面一句一句各自接一次,遲早有一頁忘了接
// 或接得不一樣。給 engagementId 就可點,不給就是純顯示（詳情頁的章不需要——
// 使用者已經站在那張單上了）。
// nowrap 是刻意的：表格會把可換行的欄縮到最長單字的寬度，連「Awaiting
// Signed Financial Statements」都會被折成兩行。句子長度靠 label 本身控制（engagementStage 的
// STAGE_LABELS 用「CW / CC / Team」縮寫，不用全名）。
const chipCls = 'inline-flex items-center whitespace-nowrap px-2 py-0.5 rounded text-[11px] font-medium';

// 只有這四關會停在等人審的狀態，也只有它們問得到「在等誰」
// （對齊後端 services/pendingReview 的 STAGES）。
const ASKABLE = ['qc', 'cwcc', 'fs', 'qc35'];

export const StageChip = ({ state, engagementId = null, stageKey = null }) => {
  const meta = STAGE_META[state] || STAGE_META.none;
  const chip = <span className={`${chipCls} ${meta.cls}`} title={meta.hint || meta.label}>{meta.label}</span>;
  // 'qm'（CW / CC / Team 核准、等 QM 執行）也點得開——小卡的 Stage 2 會列出 QM 是誰。
  if (!['pending', 'qm'].includes(state) || !ASKABLE.includes(stageKey)) return chip;
  return (
    <PendingReviewTrigger engagementId={engagementId} stage={stageKey}>
      {chip}
    </PendingReviewTrigger>
  );
};

const EngagementStageBadge = ({ stage, className = '', engagementId = null }) => {
  if (!stage) return <span className="text-slate-400">—</span>;
  const badge = (
    <span className={`${chipCls} ${STAGE_TONE_CLS[stage.tone] || STAGE_TONE_CLS.todo} ${className}`}>
      {stage.label}
    </span>
  );
  if (stage.tone !== 'pending' || !ASKABLE.includes(stage.key)) return badge;
  return (
    <PendingReviewTrigger engagementId={engagementId} stage={stage.key}>
      {badge}
    </PendingReviewTrigger>
  );
};

export default EngagementStageBadge;
